module.exports = __webpack_public_path__ + "assets/img/computer-logo.66f67abd.svg";